window.mapMoving = function (containerClass, mapClass, mapUrl) {
    const mapImage = document.querySelector(mapClass);
    const mapContainer = document.querySelector(containerClass);

    function centerMap() {
        const containerWidth = mapContainer.offsetWidth;
        const containerHeight = mapContainer.offsetHeight;
        const imageWidth = mapImage.width;
        const imageHeight = mapImage.height;

        const centerX = (imageWidth - containerWidth) / 2;
        const centerY = (imageHeight - containerHeight) / 2;

        mapImage.style.left = -centerX + 'px';
        mapImage.style.top = -centerY + 'px';
    }

    let isDragging = false;
    let isRealDragging = false;
    let startX, startY;

    mapImage.addEventListener('mousedown', (e) => {
        // Click by main (left) button.
        if (e.button === 0) {
            isDragging = true;
            startX = e.clientX - mapImage.offsetLeft;
            startY = e.clientY - mapImage.offsetTop;
            mapContainer.style.cursor = 'grabbing';
        }
    });

    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            isRealDragging = true;

            const x = e.clientX - startX;
            const y = e.clientY - startY;

            const maxX = 0;
            const maxY = 0;
            const minX = mapContainer.offsetWidth - mapImage.width;
            const minY = mapContainer.offsetHeight - mapImage.height;

            mapImage.style.left = Math.min(Math.max(x, minX), maxX) + 'px';
            mapImage.style.top = Math.min(Math.max(y, minY), maxY) + 'px';
        }
    });

    document.addEventListener('mouseup', (event) => {
        if (isDragging) {
            // Not dragged and click by main (left) button.
            if (isRealDragging === false && event.button === 0) {
                window.open(mapUrl, '_blank');
            }

            isDragging = false;
            isRealDragging = false;
            mapContainer.style.cursor = 'grab';
        }
    });

    window.addEventListener('resize', centerMap);

    centerMap();
}
